import { render, staticRenderFns } from "./DatosAcceso.vue?vue&type=template&id=c04e923c"
import script from "./DatosAcceso.vue?vue&type=script&lang=js"
export * from "./DatosAcceso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports